import type { FC } from 'react'
import { useState } from 'react'

import VerifyButton from '@/components/VerifyButton'
import type { Document, ReferenceTier, Sanctions } from '@/lib/apollo/query/get-applicant'
import type { IdentityVerification, IdentityProvider } from '@/types/Activity'
import type { OverallOutcomeStatus } from '@/types/Outcome'

import Sidebar from './Sidebar'

interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  fullName: string
  firstName: string
  middleName?: string
  lastName: string
  nationality?: string
  dateOfBirth: string | null
  r2RShareCode?: string
  companyNamedOfficer: boolean | null
  letterOfAuthorityProvided: boolean | null
  facialMatch: boolean
  hasR2RChecks: boolean
  hasIdentityChecks: boolean
  documents: Document[]
  idEvidenceDocuments: Document[]
  idType: string
  subjectType: string
  referenceTier: ReferenceTier
  onSuccess: () => void
  identityVerification?: IdentityVerification
  sanctions?: Sanctions
  overallOutcomeStatus?: OverallOutcomeStatus
  identityProvider?: IdentityProvider
}

const EditId: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  fullName,
  firstName,
  middleName,
  lastName,
  nationality,
  dateOfBirth,
  documents,
  companyNamedOfficer,
  idEvidenceDocuments,
  idType,
  onSuccess,
  r2RShareCode,
  hasR2RChecks,
  hasIdentityChecks,
  subjectType,
  referenceTier,
  identityVerification,
  letterOfAuthorityProvided,
  facialMatch,
  sanctions,
  overallOutcomeStatus,
  identityProvider,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <Sidebar
          customerId={customerId}
          applicationId={applicationId}
          subjectId={subjectId}
          fullName={fullName}
          firstName={firstName}
          middleName={middleName}
          lastName={lastName}
          nationality={nationality}
          dateOfBirth={dateOfBirth}
          r2RShareCode={r2RShareCode}
          companyNamedOfficer={companyNamedOfficer}
          hasIdentityChecks={hasIdentityChecks}
          hasR2RChecks={hasR2RChecks}
          documents={documents}
          idEvidenceDocuments={idEvidenceDocuments}
          idType={idType}
          subjectType={subjectType}
          referenceTier={referenceTier}
          onClose={() => setIsSidebarOpen(false)}
          onSuccess={onSuccess}
          identityVerification={identityVerification}
          letterOfAuthorityProvided={letterOfAuthorityProvided}
          facialMatch={facialMatch}
          sanctions={sanctions}
          overallOutcomeStatus={overallOutcomeStatus}
          identityProvider={identityProvider}
        />
      )}
      <VerifyButton onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default EditId
